const locale = {
	// Main Page
	ROOMIE_AI_TITLE: 'RoomieAI is an Artifical Intelligence for tasks management',
    ROOMIE_AI_SUBTITLE: 'Intelligent room assignment and cleaning management powered by AI',
    
    // Tasks Assignment Page
    TASKS_PAGE_TITLE: 'Tasks Management',
    TASKS_PAGE_DESC: 'Manage the tasks of your cleaning staff with ease and keep track of the performance of each of them',
	
	// Tabs
	CALENDAR_TAB: 'Calendar',
	DASHBOARD_TAB: 'Dashboard',
	ANALYTICS_TAB: 'Analytics',
	SETTINGS_TAB: 'Settings',

	// Dashboard
	ASSIGNMENT_DASHBOARD: 'Assignment Dashboard',
	REFRESH: 'Refresh',
	LAST_UPDATED: 'Last updated',
	TOTAL_ASSIGNMENTS: 'Total Assignments',
	PENDING: 'Pending',
	ESTIMATED_TIME: 'Estimated Time',
	MINUTES_TOTAL: ' minutes total',
	CLEANER_WORKLOADS: 'Current Tasks',
	RECENT_ACTIVITY: 'Recent Activity',
	WORKLOAD: 'Workload',
	TIME: 'Time',
	EFFICIENCY: 'Efficiency',
	NO_ASSIGNMENTS_TODAY: 'No assignments for today',
	NO_RECENT_ACTIVITY: 'No recent activity',
	COMPLETE_PROGRESS: '{{progress}}% complete',
	OF: 'of',
	PERFORMANCE_SUMMARY_LAST_7_DAYS: 'Performance Summary (Last 7 Days)',

	// Analytics
	PERFORMANCE_ANALYTICS: 'Performance Analytics',
	TIME_PERIOD: 'Time Period',
	LAST_7_DAYS: 'Last 7 days',
	LAST_30_DAYS: 'Last 30 days',
	LAST_90_DAYS: 'Last 90 days',
	TOTAL_RECORDS: 'Total Records',
	AVG_DURATION_MIN: 'Avg Duration (min)',
	AVG_QUALITY_SCORE: 'Avg Quality Score',
	ACTIVE_CLEANERS: 'Active Cleaners',
	PERFORMANCE_BY_ROOM_TYPE: 'Performance by Room Type',
	CLEANER_EFFICIENCY: 'Cleaner Efficiency',
	COMPLETION_TRENDS: 'Completion Trends',
	TOP_PERFORMERS: 'Top Performers',
	RECORDS: 'Records',
	NO_PERFORMANCE_DATA: 'No performance data available',
	EFFICIENCY_PERCENTAGE: 'Efficiency',
	QUALITY_VS_SPEED: 'Quality vs Speed',
	ROOM_TYPE_DISTRIBUTION: 'Room Type Distribution',
	ROOM_TYPE_PERFORMANCE_DETAILS: 'Room Type Performance Details',
	CLEANER_PERFORMANCE_DETAILS: 'Cleaner Performance Details',
	PERFORMANCE_TRENDS: 'Performance Trends',
	COUNT: 'Count',
	ASSIGNMENTS: 'Assignments',
	AVG_DURATION: 'Avg Duration',
	AVG_QUALITY: 'Avg Quality',

	// Settings
	ROOMIE_AI_SETTINGS: 'RoomieAI Settings',
	RESET: 'Reset',
	SAVE_CHANGES: 'Save Changes',
	SETTINGS_SAVED_SUCCESS: 'Settings saved successfully!',
	
	// Auto Assignment Settings
	AUTO_ASSIGNMENT: 'Auto Assignment',
	ENABLE_AUTO_DAILY_ASSIGNMENTS: 'Enable automatic daily assignments',
	DAILY_GENERATION_TIME: 'Daily generation time',
	ASSIGNMENT_ALGORITHM: 'Assignment algorithm',
	AUTO_SELECT_BEST: 'Auto-select best algorithm',
	MIN_PERFORMANCE_RECORDS: 'Minimum performance records needed for performance-based algorithm',
	PERFORMANCE_WINDOW_DAYS: 'Performance evaluation window (days)',
	
	// Notification Settings
	NOTIFICATIONS: 'Notifications',
	ASSIGNMENT_GENERATED_NOTIFICATION: 'Notify when assignments are generated',
	ASSIGNMENT_COMPLETED_NOTIFICATION: 'Notify when assignments are completed',
	PERFORMANCE_ALERTS: 'Send performance alerts',
	DAILY_REPORTS: 'Send daily summary reports',
	
	// Performance Settings
	PERFORMANCE_TRACKING: 'Performance Tracking',
	TRACK_QUALITY_SCORES: 'Track quality scores for completed assignments',
	AUTO_RECORD_TIMES: 'Automatically record cleaning times',
	REQUIRE_NOTES: 'Require completion notes',
	QUALITY_THRESHOLD: 'Quality score threshold for alerts',
	
	// Workload Settings
	WORKLOAD_MANAGEMENT: 'Workload Management',
	MAX_ROOMS_PER_CLEANER: 'Maximum rooms per cleaner per day',
	MAX_HOURS_PER_DAY: 'Maximum hours per cleaner per day',
	BALANCE_WORKLOAD: 'Automatically balance workload between cleaners',
	CONSIDER_ROOM_TYPES: 'Consider room types when balancing workload',
	
	// Cleaning Time Settings
	CLEANING_TIMES: 'Default Cleaning Times',
	ALLOW_OVERLAPPING: 'Allow overlapping assignments',
	ROOM_TYPE_TIMES: 'Room Type Times',
	MINUTES: 'minutes',
	
	// Algorithm Settings
	ALGORITHM_SETTINGS: 'Algorithm Settings',
	PERFORMANCE_WEIGHT: 'Performance weight (0-100%)',
	DISTANCE_WEIGHT: 'Distance/floor weight (0-100%)',
	WORKLOAD_WEIGHT: 'Workload balance weight (0-100%)',
	
	// Advanced Settings
	ADVANCED_SETTINGS: 'Advanced Settings',
	ENABLE_AI_LEARNING: 'Enable AI learning from historical data',
	DATA_RETENTION_DAYS: 'Data retention period (days)',
	BACKUP_FREQUENCY: 'Backup frequency',
	DAILY: 'Daily',
	WEEKLY: 'Weekly',
	MONTHLY: 'Monthly',
	
	// Status Messages
	CHANGES_SAVED: 'Changes saved successfully',
	CHANGES_DISCARDED: 'Changes discarded',
	INVALID_SETTINGS: 'Please check your settings for invalid values',
	DAILY_ASSIGNMENT_TIME: 'Daily Assignment Time',
	DEFAULT_ALGORITHM: 'Default Algorithm',
	AUTO_DETECT_BEST: 'Auto-detect best',
	MINIMUM_PERFORMANCE_RECORDS: 'Minimum Performance Records',
	PERFORMANCE_WINDOW: 'Performance Window',
	ASSIGNMENT_GENERATED: 'Assignment generated',
	ASSIGNMENT_COMPLETED: 'Assignment completed',
	TRACK_QUALITY_SCORES_LABEL: 'Track quality scores',
	AUTO_RECORD_CLEANING_TIMES: 'Auto-record cleaning times',
	REQUIRE_COMPLETION_NOTES: 'Require completion notes',
	QUALITY_THRESHOLD_LABEL: 'Quality Threshold',
	DAYS: 'days',
	ENABLE_AUTO_ASSIGNMENT: 'Enable automatic daily assignments',
	CLEANING_CONFIGURATION: 'Cleaning Configuration',
	DEFAULT_CLEANING_TIMES: 'Default Cleaning Times (minutes)',
	BUFFER_TIME: 'Buffer Time Between Assignments',
	ALLOW_OVERLAPPING_ASSIGNMENTS: 'Allow overlapping assignments',
	SETTINGS_SAVED_SUCCESSFULLY: 'Settings saved successfully!',
	ESTIMATED_TOTAL_TIME: 'Estimated Total Time',
	FILTER: 'Filter',
	PERFORMANCE_METRICS: 'Performance Metrics',

	// Header and Navigation
	ROOMS: 'Rooms',
	LIST: 'List', 
	TIMELINE: 'Timeline',
	OVERVIEW: 'Overview',
	FILTERS: 'Filters',
	GENERATE_AI: 'Generate with RoomieAI',
	AI: 'AI',
	SEARCH: 'Search',
	
	// Statistics and Summary
	TOTAL: 'Total',
	DONE: 'Done',
	RATE: 'Rate',
	ASSIGNED: 'Assigned',
	UNASSIGNED: 'Unassigned', 
	COMPLETED: 'Completed',
	IN_PROGRESS: 'In Progress',
	ASSIGNMENT_RATE: 'Assignment Rate',
	COMPLETION_RATE: 'Completion Rate',
	TOTAL_DURATION: 'Total Duration',
	CREATED_DATE: 'Creation Date',
	
	// Room Status
	ASSIGNED_STATUS: 'Assigned',
	ASSIGNED_NOT_COMPLETED_STATUS: 'Assigned, but not completed',
	IN_PROGRESS_STATUS: 'In Progress',
	COMPLETED_STATUS: 'Completed',
	UNASSIGNED_STATUS: 'Unassigned',
	OVERDUE: 'Overdue',
	CANCELLED: 'Cancelled',
	SKIPPED: 'Skipped',
	REASSIGNED: 'Reassigned',
	
	// Status (singular forms for tooltips)
	ASSIGNED_SINGULAR: 'Assigned',
	COMPLETED_SINGULAR: 'Completed',
	IN_PROGRESS_SINGULAR: 'In Progress',
	CANCELLED_SINGULAR: 'Cancelled',
	SKIPPED_SINGULAR: 'Skipped',
	
	// Actions
	ASSIGN_TO_CLEANER: 'Assign to Cleaner',
	REASSIGN: 'Reassign',
	CANCEL_ASSIGNMENTS: 'Cancel Assignments',
	CANCEL: 'Cancel',
	BULK_REASSIGN: 'Bulk Reassign',
	SELECT_ALL: 'Select full floor',
	DESELECT_ALL: 'Deselect full floor',
	SELECT_FLOOR: 'Select floor',
	DESELECT: 'Deselect',
	START_CLEANING: 'Start Cleaning',
	REASSIGN_ALL: 'Reassign all',
	
	// Search and Filters
	SEARCH_PLACEHOLDER: 'Room number, cleaner, floor...',
	SEARCH_PLACEHOLDER_DETAILED: 'Room number, cleaner name, floor...',
	SHOW_UNASSIGNED_ONLY: 'Show unassigned only',
	CLEAR_FILTERS: 'Clear Filters',
	ALL_STATUSES: 'All Statuses',
	ALL_CLEANERS: 'All Cleaners',
	ALL_FLOORS: 'All Floors',
	ALL_ROOM_TYPES: 'All Room Types',
	STATUS: 'Status',
	LEGEND: 'Legend',
	CLEANER: 'Cleaner',
	FLOOR: 'Floor',
	ROOM_TYPE: 'Room Type',
	
	// Generate AI Dialog
	GENERATE_AI_ASSIGNMENTS: 'Generate AI Assignments',
	SELECT_CLEANERS: 'Select Cleaners',
	ALGORITHM_OPTIONAL: 'Algorithm (Optional)',
	AUTO_DETECT_ALGORITHM: 'Auto-detect best algorithm',
	PERFORMANCE_BASED: 'Performance-based',
	FLOOR_BASED: 'Floor-based',
	DATE_LABEL: 'Date',
	GENERATE_ASSIGNMENTS: 'Generate Assignments',
	
	// Room and Assignment Details
	ROOM: 'Room',
	ROOM_NUMBER: 'Room {{number}}',
	FLOOR_NUMBER: 'Floor {{number}}',
	DURATION_MINUTES: '{{minutes}}min',
	DURATION_HOURS: '{{hours}}h {{minutes}}m',
	PRIORITY_LEVEL: 'Priority Level',
	ESTIMATED_DURATION: 'Estimated Duration',
	CLEANING_EMPLOYEE: 'Cleaning Employee',
	TYPE: 'Type',
	
	// Room Types
	STANDARD_ROOM: 'Standard Room',
	SINGLE_ROOM: 'Single Room',
	DOUBLE_ROOM: 'Double Room',
	TWIN_ROOM: 'Twin Room',
	TRIPLE_ROOM: 'Triple Room',
	QUEEN_ROOM: 'Queen Room',
	KING_ROOM: 'King Room',
	STUDIO_ROOM: 'Studio Room',
	SUITE: 'Suite',
	JUNIOR_SUITE: 'Junior Suite',
	PRESIDENTIAL_SUITE: 'Presidential Suite',
	
	// Priority Levels
	EXPRESS: 'Express',
	CHECKOUT: 'Checkout',
	NORMAL: 'Normal',
	
	// Priority Explanations
	EXPRESS_PRIORITY_EXPLANATION: 'Express cleaning request - highest priority',
	CHECKOUT_PRIORITY_EXPLANATION: 'Checkout cleaning - guest is leaving',
	NORMAL_PRIORITY_EXPLANATION: 'Normal cleaning priority - standard room cleaning',
	
	// Room Conditions
	REGULAR_ROOM_CONDITION: 'Regular room condition',
	EXTRA_DIRTY_ROOM: 'Room requires extra cleaning attention',
	MAINTENANCE_NEEDED_ROOM: 'Room has maintenance issues that need addressing',
	VIP_GUEST_ROOM: 'VIP guest room - highest service standard required',
	
	// Table Headers
	ACTIONS: 'Actions',
	PRIORITY: 'Priority',
	DURATION: 'Duration',
	
	// Dialogs and Messages
	REASSIGN_ROOM: 'Reassign Room {{roomNumber}}',
	SELECT_NEW_CLEANER: 'Select New Cleaner',
	SELECT_CLEANER: 'Select Cleaner', 
	REASON_OPTIONAL: 'Reason (optional)',
	REASON_PLACEHOLDER: 'Enter reason for reassignment...',
	MANUAL_REASSIGNMENT: 'Manual reassignment',
	
	// Bulk Operations
	BULK_REASSIGN_TITLE: 'Bulk Reassign {{count}} {{type}}',
	ROOMS_SELECTED: '{{count}} rooms selected',
	ASSIGNMENTS_SELECTED: '{{count}} assignments selected', 
	ROOM_SINGULAR: 'room',
	ROOMS_PLURAL: 'rooms',
	ASSIGNMENT_SINGULAR: 'assignment',
	ASSIGNMENTS_PLURAL: 'assignments',
	BULK_REASSIGN_WARNING: 'You are about to reassign {{count}} {{type}} to a new cleaner.',
	BULK_REASSIGNMENT_REASON: 'Enter reason for bulk reassignment...',
	BULK_REASSIGNMENT_FROM_ROOMS: 'Bulk reassignment from rooms view',
	BULK_REASSIGNMENT: 'Bulk reassignment',
	
	// Assignment Dialog
	ASSIGN_ROOMS_TO_CLEANER_one: 'Assign {{count}} Room to Cleaner',
	ASSIGN_ROOMS_TO_CLEANER_other: 'Assign {{count}} Rooms to Cleaner',
	ASSIGNING_ROOMS_FOR_DATE_one: 'Assigning {{count}} room for {{date}}',
	ASSIGNING_ROOMS_FOR_DATE_other: 'Assigning {{count}} rooms for {{date}}',
	ASSIGNING: 'Assigning...',
	ASSIGN_ROOMS_BUTTON_one: 'Assign {{count}} Room',
	ASSIGN_ROOMS_BUTTON_other: 'Assign {{count}} Rooms',
	
	// Priority Change
	CHANGE_PRIORITY_FOR_ROOMS_one: 'Change Priority for {{count}} Assignment',
	CHANGE_PRIORITY_FOR_ROOMS_other: 'Change Priority for {{count}} Assignments',
	SELECT_NEW_PRIORITY_LEVEL: 'Select the new priority level for the selected assignments:',
	PRIORITY_CHANGE_EXPLANATION: 'This will immediately update the priority level for all selected assignments.',
	UPDATE_PRIORITY: 'Update Priority',
	UPDATING: 'Updating...',
	
	// Today's Summary
	TODAYS_SUMMARY: "Today's Summary",
	CLEANER_PERFORMANCE: 'Cleaner Performance',
	ASSIGNMENTS_COUNT: '{{count}} assignments',
	
	// Floor Statistics
	PROGRESS: 'Progress',
	
	// Loading and Status Messages
	LOADING: 'Loading...',
	NO_SESSIONS_FOUND: 'No cleaning sessions found',
	UNKNOWN_CLEANER: 'Unknown Cleaner',
	UNKNOWN_TYPE: 'Unknown Type',
	UNKNOWN_FLOOR: 'Unknown',
	
	// Date Navigation
	PREVIOUS_DAY: 'Previous Day',
	NEXT_DAY: 'Next Day',
	
	// View Mode Messages
	NO_ASSIGNMENTS_MORE: '+{{count}} more assignments',
	
	// Success Messages
	ASSIGNMENTS_GENERATED: 'Assignments generated successfully',
	REASSIGNMENT_SUCCESSFUL: 'Reassignment completed successfully',
	ASSIGNMENT_CANCELLED: 'Assignment cancelled successfully',
	
	// Error Messages
	SELECT_CLEANER_FIRST: 'Please select a cleaner first',
	SELECT_ROOMS_FIRST: 'Please select rooms first',
	NO_ROOMS_SELECTED: 'No rooms selected',
	
	// Menu Actions
	START_MANUALLY: 'Started manually',
	CANCELLED_BY_ADMIN: 'Cancelled by admin',
	
	// Time Formatting
	HOURS_SHORT: 'h',
	MINUTES_SHORT: 'm',
	
	// Duration Messages
	DURATION_IN_PROGRESS: 'Will show after completion',
	DURATION_NOT_STARTED: 'Not started yet',
	
	// Express and Checkout priorities
	EXPRESS_ASSIGNED: 'Express assigned - dark red',
	EXPRESS_IN_PROGRESS: 'Express in progress - bright red', 
	EXPRESS_COMPLETED: 'Express completed - dark green',
	CHECKOUT_ASSIGNED: 'Checkout assigned - orange',
	CHECKOUT_IN_PROGRESS: 'Checkout in progress - bright orange',
	CHECKOUT_COMPLETED: 'Checkout completed - dark green',
	
	// Recent Activity Messages
	WAS_ASSIGNED_TO: 'was assigned to',
	WAS_STARTED_BY: 'was started by',
	WAS_COMPLETED_BY: 'was completed by',
	
};

export default locale; 